export const classes = {
  stepper: 'flex items-center gap-1',
  button:
    'place-center size-8 cursor-pointer rounded-[9px] border border-hair bg-panel text-taupe-2 transition-colors duration-150 hover:bg-black/[0.1] hover:text-taupe-3 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-transparent dark:border-hair-dark dark:bg-panel-dark dark:text-mauve-2 dark:hover:bg-white/[0.1] dark:hover:text-mauve-1',
  value:
    'min-w-10 text-center text-[17px] font-bold text-taupe-3 dark:text-mauve-1',
};
